import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import bindMethods from 'auto-bind';

import { fetchAllOrgs } from '../../state/orgs';
import { fetchAllProducts } from '../../state/products';
import { fetchAllUsers } from '../../state/users';
import { fetchAllRoles } from '../../state/roles';
import PageTitle from '../../components/PageTitle';
import SSOButton from '../../components/SSOButton';
import AddIcon from '../../icons/AddIcon';
import OrgsTable from '../../components/tables/OrgsTable';
import { HeadlineContainer } from '../../components/form/FormStyles';

class ListOrgs extends PureComponent {
  constructor(props) {
    super(props);
    bindMethods(this);
  }

  componentDidMount() {
    const {
      fetchAllOrgs,
      isAllOrgsLoaded,
      fetchAllProducts,
      isAllProductsLoaded,
      isAllUsersLoaded,
      fetchAllUsers,
      fetchAllRoles,
      isAllRolesLoaded,
    } = this.props;

    if (!isAllOrgsLoaded) {
      fetchAllOrgs();
    }

    if (!isAllProductsLoaded) {
      fetchAllProducts();
    }

    if (!isAllUsersLoaded) {
      fetchAllUsers();
    }

    if (!isAllRolesLoaded) {
      fetchAllRoles();
    }
  }

  handleAddNewOrgClick() {
    const { history } = this.props;
    history.push('/orgs/new');
  }

  render() {
    const {
      t,
      isAllOrgsLoaded,
      isAllProductsLoaded,
      isAllUsersLoaded,
      isAllRolesLoaded,
      orgs,
    } = this.props;

    if (!isAllOrgsLoaded || !isAllProductsLoaded || !isAllUsersLoaded || !isAllRolesLoaded) {
      return null;
    }

    return (
      <div>
        <HeadlineContainer>
          <PageTitle title={t('Pages.Orgs.Headlines.Title')} />
          <SSOButton
            id="Orgs.AddNewOrg"
            icon={AddIcon}
            onClick={this.handleAddNewOrgClick}
            text={t('Pages.Orgs.Actions.AddOrg')}
            isSmall
          />
        </HeadlineContainer>

        <OrgsTable orgs={orgs} />
      </div>
    );
  }
}

ListOrgs.propTypes = {
  fetchAllOrgs: PropTypes.func.isRequired, // supplied from Redux
  isAllOrgsLoaded: PropTypes.bool.isRequired, // supplied from Redux
  orgs: PropTypes.array.isRequired, // supplied from Redux
  fetchAllProducts: PropTypes.func.isRequired, // supplied from Redux
  isAllProductsLoaded: PropTypes.bool.isRequired, // supplied from Redux
  isAllUsersLoaded: PropTypes.bool.isRequired, // supplied from Redux
  fetchAllRoles: PropTypes.func.isRequired, // supplied from Redux
  isAllRolesLoaded: PropTypes.bool.isRequired, // supplied from Redux
  t: PropTypes.func.isRequired, // supplied from withTranslation
  history: PropTypes.object.isRequired, // supplied from React Router
  fetchAllUsers: PropTypes.func.isRequired, // supplied from Redux
};

const mapStateToProps = state => ({
  isAllOrgsLoaded: state.orgs.isAllOrgsLoaded,
  isAllRolesLoaded: state.roles.isAllRolesLoaded,
  orgs: state.orgs.orgs,
  isAllProductsLoaded: state.products.isAllProductsLoaded,
  products: state.products.products,
  isAllUsersLoaded: state.users.isAllUsersLoaded,
});

const mapDispatchToProps = {
  fetchAllOrgs,
  fetchAllProducts,
  fetchAllUsers,
  fetchAllRoles,
};

const TranslatedComponent = withTranslation()(ListOrgs);
export default connect(mapStateToProps, mapDispatchToProps)(TranslatedComponent);
